import React from "react";

const MovieSkeleton = () => {
  return (
    <div className="w-[160px] sm:w-[200px] md:w-[240px] lg:w-[280px] h-[90px] md:h-[160px] inline-block cursor-pointer relative p-2 bg-gray-400 animate-pulse rounded-md"></div>
  );
};
export default MovieSkeleton;
